<template>
  <main>
    <InputFilter class="pt-10" :pagination="pagination" />

    <v-container>
      <v-toolbar flat class="main-header">
        <v-toolbar-title class="main-header__title">
          <h1>Receipts</h1>
        </v-toolbar-title>
      </v-toolbar>
      <hr class="my-6" />
      <v-btn rounded large color="white" to="/bookings" class="mb-6 px-10 shade"
        ><strong>Bookings</strong></v-btn
      >
      <v-data-table
        :headers="headers"
        :loading="loadingDataTable"
        :items="reciepts"
        :mobile-breakpoint="0"
        :items-per-page="20"
        hide-default-footer
        class="table teams"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell name text-center">
              {{ item ? item.order_no : "---" }}
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.receipt_no : "---" }}
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.payment_method : "---" }}
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.cashier : "---" }}
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.status : "---" }}
            </td>
            <td class="table__cell name text-center">
              {{ item.email || "---" }}
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.mobile : "---" }}
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.account_no : "---" }}
            </td>
            <td class="table__cell text-center">
              <v-btn
                class="hovering"
                color="success"
                rounded
                small
                @click="handlePrint(item, index)"
              >
                <span v-if="item.is_printed == 0">Print</span>
                <span v-else>Copy</span>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="reciepts.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
    <printed-receipt
      :item="item"
      id="section-to-print"
      :class="{ isCopied: item.is_printed != 0 }"
    ></printed-receipt>
  </main>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, ShowData, StoreData } from "@/helpers/apiMethods";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      headers: [],
      reciepts: [],
      loadingDataTable: false,
      pagination: {},
      item: {}
    };
  },
  components: {
    PrintedReceipt: () => import("./components/PrintedReceipt"),
    InputFilter: () => import("@/views/accounts/components/InputFilter")
  },
  created() {
    this.createTableHeaders();
  },
  methods: {
    indexreciepts(query) {
      this.loadingDataTable = true;
      IndexData({ reqName: `receipts`, query })
        .then(res => {
          const { data, meta } = res.data;
          this.reciepts = data;
          this.pagination = meta;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = [
        "Order ID",
        "Reciept No",
        "Payment Method",
        "Cashier",
        "Status",
        "Email",
        "Mobile",
        "Account No",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    handlePrint(item) {
      ShowData({
        reqName: `receipts`,
        id: item.id
      })
        .then(res => {
          const { receipt } = res.data;
          this.item = receipt;
          if (receipt.is_printed == 0) {
            StoreData({
              reqName: `/receipts/print`,
              data: { receipt_id: item.id }
            })
              .then(() => {
                this.indexreciepts(this.$route.query);
              })
              .catch(() => {});
          }
          this.$nextTick(() => {
            window.print(receipt);
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.pagination.current_page = query.page;
        this.indexreciepts(query);
      },
      immediate: true
    }
  }
};
</script>
